import { X, CheckCircle, AlertCircle, Loader2, Image, Video } from "lucide-react";
import { formatBytes } from "../../utils/utils-file";

export default function FileCard({ file, onRemove, disabled }) {
  return (
    <article className={`card ${file.status}`}>
      <div className="thumb">
        {file.type === "video" ? (
          <video src={file.preview} muted />
        ) : (
          <img src={file.preview} alt="" />
        )}
        <span className="type">
          {file.type === "video" ? (
            <Video size={12} />
          ) : (
            <Image size={12} />
          )}
        </span>
        <button
          className="remove"
          onClick={() => onRemove(file.id)}
          disabled={disabled}
        >
          <X size={14} />
        </button>
      </div>
      <div className="meta">
        <p className="name" title={file.name}>
          {file.name}
        </p>
        <p className="size">{formatBytes(file.size)}</p>
        {file.status === "uploading" && (
          <p className="stat up">
            <Loader2 size={12} className="spin" /> Uploading
          </p>
        )}
        {file.status === "success" && (
          <p className="stat ok">
            <CheckCircle size={12} /> Done
          </p>
        )}
        {file.status === "error" && (
          <p className="stat err">
            <AlertCircle size={12} /> Failed
          </p>
        )}
      </div>
    </article>
  );
}